import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.path('/websites/{?id}')
@doc.timestampable
abstract class AbstractWebsiteModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'name': id;
		'url': id;
		'showUrn': Urn;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		name: string;
		url: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare name: string;
	@doc.string declare url: string;
	declare abstract show: unknown;
}

interface AbstractWebsiteModel extends Timestampable {}

export default AbstractWebsiteModel;
